import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import App from "./App";
import "./styles/index.css";
import "./styles/login.css";
import "./styles/dashboard.css";

dayjs.locale("zh-cn");

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          colorPrimary: "#14b8a6",
          borderRadius: 12,
          colorError: "#dc2626",
        },
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>
);
